import {ModalProps} from "react-bootstrap/Modal";
import {Button, Modal, ToggleButton} from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";
import {
    ModalReceiverContainer,
    ModalReceiverHeader,
    ModalReceiverMode,
    ModalReceiverNow,
    ModalReceiverOnOff,
    ModalReceiverSection,
    ModalReceiverSectionHeader, ModalReceiverSectionWithTab,
    ModalReceiverSelect,
    ModalReceiverSound,
    ModalReceiverText,
    ModalReceiverVolume
} from "./ModalReceiverStyle";
import {ArrowLeft, ArrowRight, Play, Power, VolumeMute, VolumeUp} from "react-bootstrap-icons";
import SelectNew, {ISelect} from "../../component/SelectComponent/SelectNew";
import {jsx} from "@emotion/react";
import {actions as websocket, IReceiver, IReceiverControl} from "../../store/sliceWebsocket";
import {radioWave} from "../../utils/RadioWave";
import NetUsbControl from "./netUsb/NetUsbControl";
import JSX = jsx.JSX;
import {
    fetchReceiverFreq,
    fetchReceiverMode, fetchReceiverMute,
    fetchReceiverPower,
    fetchReceiverStatus,
    fetchReceiverVolume
} from "../../fetch/RequestReceiver";


const ModalReceiver: FC<ModalProps> = (props) => {
    const dispatch = useDispatch<AppDispatch>();

    const receiver: IReceiver = useSelector((state: IRootState) => state.websocket.receiver)
    const receiverNetControl: IReceiverControl = useSelector((state: IRootState) => state.websocket.receiverNetRadioControl)
    const receiverUsbControl: IReceiverControl = useSelector((state: IRootState) => state.websocket.receiverUsbControl)


    const [volume, setVolume] = useState(0)
    const [wave, setWave] = useState<ISelect>({value: "Русское радио", description: "104.1"} as ISelect)


    const options: ISelect[] = radioWave

    useEffect(() => {
        setVolume(receiver.volume)
    }, [receiver.volume])


    const sendVolume = useCallback((changeEvent: React.ChangeEvent<HTMLInputElement>) => {
        const volumeValue = Number(changeEvent.target.value)
        setVolume(volumeValue);
        setTimeout(() => {
            dispatch(websocket.send({
                body: JSON.stringify({volume: volumeValue}),
                topic: "/app/receiver.volume"
            }))
        }, 500);
    },[])

    const radioControl = useCallback((): JSX.Element => {
        return <div style={{width: "100%"}}>
            <ModalReceiverText style={{marginBottom: "5px"}}>Выберите радио или введите волну в формате 104.5</ModalReceiverText>
            <ModalReceiverSelect>
                <div style={{width: "100%"}}>
                    <SelectNew options={options} value={"Русское радио"} onSelect={item => setWave(item)}/>
                </div>
                <Play size={40} onClick={() => {
                    fetchReceiverFreq(`${Number(wave.description) * 1000}`)
                    // dispatch(websocket.send({
                    //     body: `${Number(wave.description) * 1000}`,
                    //     topic: "/app/receiver.freq"
                    // }))
                }}/>
            </ModalReceiverSelect>
        </div>
    },[wave])


    const onMute = useCallback(() => {
        fetchReceiverMute()
        // dispatch(websocket.send({
        //     body: "",
        //     topic: "/app/receiver.mute"
        // }))
    },[])

    const onPower = useCallback(() => {
        fetchReceiverPower()
        // dispatch(websocket.send({
        //     body: "",
        //     topic: "/app/receiver.power"
        // }))
    },[])

    const onStatus = useCallback(() => {
        // dispatch(websocket.send({
        //     body: "",
        //     topic: "/app/receiver.status"
        // }))
        fetchReceiverStatus()
        dispatch(websocket.send({
            body: JSON.stringify({index: 0, input: "net_radio"}),
            topic: "/app/receiver.netRadio.info"
        }))
        dispatch(websocket.send({
            body: JSON.stringify({index: 0, input: "usb"}),
            topic: "/app/receiver.usb.info"
        }))
    },[])

    const onVolume = useCallback((mode: string) => {
        fetchReceiverVolume({step: 5, mode: mode})
        // dispatch(websocket.send({
        //     body: JSON.stringify({step: 5, mode: mode}),
        //     topic: "/app/receiver.volume"
        // }))
    },[])


    const playNow = useCallback((): JSX.Element => {
        return <ModalReceiverNow>
            <ModalReceiverHeader>В эфире:</ModalReceiverHeader>
            <div style={{marginLeft: "10px"}}>
                {(receiver.mode?.radio) && <ModalReceiverText>Волна: {Number(receiver.playNow.wave) / 1000} FM</ModalReceiverText>}
                {(receiver.mode?.netRadio) && <ModalReceiverText>Волна: {receiver.playNow.wave}</ModalReceiverText>}

                {receiver?.playNow?.artist && <ModalReceiverText>Исполнитель: {receiver.playNow?.artist}</ModalReceiverText>}
                {receiver?.playNow?.track && <ModalReceiverText>Трэк: {receiver.playNow?.track}</ModalReceiverText>}

            </div>
        </ModalReceiverNow>;
    },[receiver?.playNow, receiver?.mode])
    return (
        <Modal
            {...props}
            fullscreen={true}
            centered
        >
            <Modal.Header closeButton style={{gap: "10px"}}>Управление ресивером</Modal.Header>
            <Modal.Body>
                <ModalReceiverContainer>
                    {/*<Stomp />*/}
                    <ModalReceiverOnOff>
                        <Button variant="outline-success" onClick={onStatus}>Обновить</Button>
                        {/*<Button variant="outline-success" onClick={() => alert(JSON.stringify(receiverNetControl))}>store</Button>*/}
                        {receiver.power && <Power size={30} color={"green"} onClick={onPower}/>}
                        {!receiver.power && <Power size={30} color={"red"} onClick={onPower}/>}
                    </ModalReceiverOnOff>
                    <ModalReceiverSection>
                        <ModalReceiverSectionHeader>Выбор режима</ModalReceiverSectionHeader>
                        <ModalReceiverMode>
                            <ToggleButton
                                id="toggle-check-net"
                                type="checkbox"
                                variant="outline-success"
                                checked={receiver?.mode?.netRadio}
                                value="1"
                                onChange={() => {
                                    fetchReceiverMode({netRadio: true})
                                    // dispatch(websocket.send({
                                    //     body: JSON.stringify({netRadio: true}),
                                    //     topic: "/app/receiver.mode"
                                    // }))
                                }}
                            >
                                {/*<JournalCheck style={{marginRight: "5px"}}/>*/}
                                <span>Net-radio</span>
                            </ToggleButton>

                            <ToggleButton
                                id="toggle-check-radio"
                                type="checkbox"
                                variant="outline-success"
                                checked={receiver?.mode?.radio}
                                value="1"
                                onChange={() => {
                                    fetchReceiverMode({radio: true})
                                    // dispatch(websocket.send({
                                    //     body: JSON.stringify({radio: true}),
                                    //     topic: "/app/receiver.mode"
                                    // }))
                                }}
                            >
                                {/*<JournalCheck style={{marginRight: "5px"}}/>*/}
                                <span>Радио</span>
                            </ToggleButton>
                            <ToggleButton
                                id="toggle-check-server"
                                type="checkbox"
                                variant="outline-success"
                                checked={receiver?.mode?.server}
                                value="1"
                                onChange={() => {
                                    fetchReceiverMode({server: true})
                                    // dispatch(websocket.send({
                                    //     body: JSON.stringify({server: true}),
                                    //     topic: "/app/receiver.mode"
                                    // }))
                                }}
                            >
                                {/*<JournalCheck style={{marginRight: "5px"}}/>*/}
                                <span>Сервер</span>
                            </ToggleButton>
                            <ToggleButton
                                id="toggle-check-bluetooth"
                                type="checkbox"
                                variant="outline-success"
                                checked={receiver?.mode?.bluetooth}
                                value="1"
                                onChange={() => {
                                    fetchReceiverMode({bluetooth: true})
                                    // dispatch(websocket.send({
                                    //     body: JSON.stringify({bluetooth: true}),
                                    //     topic: "/app/receiver.mode"
                                    // }))
                                }}
                            >
                                {/*<JournalCheck style={{marginRight: "5px"}}/>*/}
                                <span>Bluetooth</span>
                            </ToggleButton>
                            <ToggleButton
                                id="toggle-check-usb"
                                type="checkbox"
                                variant="outline-success"
                                checked={receiver?.mode?.usb}
                                value="1"
                                onChange={() => {
                                    fetchReceiverMode({usb: true})

                                    // dispatch(websocket.send({
                                    //     body: JSON.stringify({usb: true}),
                                    //     topic: "/app/receiver.mode"
                                    // }))
                                }}
                            >
                                {/*<JournalCheck style={{marginRight: "5px"}}/>*/}
                                <span>usb</span>
                            </ToggleButton>
                        </ModalReceiverMode>
                    </ModalReceiverSection>
                    <ModalReceiverSection>
                        <ModalReceiverSectionHeader>Громкость</ModalReceiverSectionHeader>
                        {/*<ModalReceiverRange>*/}
                        {/*    <RangeSlider*/}
                        {/*        value={volume}*/}
                        {/*        onChange={sendVolume}*/}
                        {/*        min={0}*/}
                        {/*        max={160}*/}
                        {/*        step={5}*/}
                        {/*        variant={"success"}*/}
                        {/*        tooltip={"off"}*/}
                        {/*    />*/}
                        {/*</ModalReceiverRange>*/}
                        <ModalReceiverSound>
                            <Button variant="outline-success"><ArrowLeft size={30} onClick={() => onVolume("down")}/></Button>
                            <ModalReceiverVolume>
                                <p>{volume}</p>
                                {!receiver.mute && <VolumeUp size={35} onClick={onMute}/>}
                                {receiver.mute && <VolumeMute size={35} onClick={onMute}/>}
                            </ModalReceiverVolume>
                            <Button variant="outline-success"><ArrowRight size={30}  onClick={() => onVolume("up")}/></Button>
                        </ModalReceiverSound>
                    </ModalReceiverSection>
                    <ModalReceiverSectionWithTab>
                        <ModalReceiverSectionHeader>Настройки</ModalReceiverSectionHeader>
                        <Tabs style={{width: "100%"}}
                            defaultActiveKey="radio"
                        >
                            <Tab style={{width: "100%"}} eventKey="radio" title="Радио">
                                {radioControl()}
                            </Tab>
                            <Tab style={{width: "100%"}} eventKey="netRadio" title="Net-Радио">
                                <NetUsbControl input={"net_radio"} iReceiverControl={receiverNetControl}/>
                            </Tab>
                            <Tab style={{width: "100%"}} eventKey="usb" title="USB">
                                <NetUsbControl input={"usb"} iReceiverControl={receiverUsbControl}/>
                            </Tab>
                        </Tabs>
                    </ModalReceiverSectionWithTab>
                    <ModalReceiverSection>
                        <ModalReceiverSectionHeader>Информация</ModalReceiverSectionHeader>
                        {playNow()}
                    </ModalReceiverSection>
                </ModalReceiverContainer>
            </Modal.Body>
        </Modal>
    )
        ;
}

export default memo(ModalReceiver)
